const initScrollSpy = (nav, onChange) => {
	const targets = [...nav.querySelectorAll('.wp-block-navigation-item')]
		.map(item => {
			const link = item.querySelector('.wp-block-navigation-item__content');
			const hash = link ? new URL(link.href).hash.slice(1) : '';
			return hash ? { item, section: document.getElementById(hash) } : null;
		})
		.filter(target => target?.section);

	if (!targets.length) return;

	const observer = new IntersectionObserver(entries => {
		entries.forEach(entry => {
			if (!entry.isIntersecting) return;

			const current = targets.find(({ section }) => section === entry.target);
			targets.forEach(target => target.item.classList.toggle('is-active', target === current));
			onChange();
		});
	}, { rootMargin: '-40% 0px -55% 0px' });

	targets.forEach(({ section }) => observer.observe(section));
};

export const initNavDropdown = () => {
	const navs = document.querySelectorAll('nav.product-nav, nav.enquire-nav');

	if (!navs.length) return;

	navs.forEach(nav => {
		const items = [...nav.querySelectorAll('.wp-block-navigation-item')];
		if (items.length < 2) return;

		const container = nav.querySelector('.wp-block-navigation__container');

		// Stands in for the active item in the collapsed mobile row. The real
		// items live in the dropdown panel (the <ul>, styled separately) so
		// it can overlay the page below instead of pushing it down.
		const current = document.createElement('a');
		current.className = 'nav-dropdown__current';
		nav.insertBefore(current, container);

		const syncCurrent = () => {
			const active = items.find(item => item.classList.contains('is-active'));
			const link = active.querySelector('.wp-block-navigation-item__content');

			current.textContent = link.textContent;
			current.href = link.getAttribute('href');
			if (link.target) current.target = link.target;
		};

		// Pin the first item by default. On navs whose links point to
		// same-page sections, the scroll-spy above takes over from here,
		// moving this to whichever section is in view.
		items[0].classList.add('is-active');
		syncCurrent();
		initScrollSpy(nav, syncCurrent);

		const toggle = document.createElement('button');
		toggle.type = 'button';
		toggle.className = 'nav-dropdown__toggle';
		toggle.setAttribute('aria-expanded', 'false');
		toggle.setAttribute('aria-label', 'Toggle menu');
		toggle.innerHTML = '<span class="caret" aria-hidden="true"></span>';

		nav.append(toggle);

		toggle.addEventListener('click', () => {
			const isOpen = nav.classList.toggle('is-open');
			toggle.setAttribute('aria-expanded', String(isOpen));
		});

		items.forEach(item => {
			item.addEventListener('click', () => {
				nav.classList.remove('is-open');
				toggle.setAttribute('aria-expanded', 'false');
			});
		});
	});
};
